<template>
  <section class="servicios col-12" v-if="true">
    <h5 class="texto-destacado d-inline-block">{{idioma.selecciona}}</h5>

    <div class="infoBtn infoBtnContinuo" data-toggle="modal" data-target="#infoServicios">
      <i class="fa icon-info info"></i>
    </div>
    <div class="msgServicios">
      <h5 class="texto-msgServicios d-inline-block">{{ getBooking().msgServicios }}</h5>
    </div>
    <div v-for="(servi,idx) in currentRefuges">
      <ServiceTable
        :bookingId="servi.booking"
        :idioma="idioma"
        :services="servi.services"
        :idRef="servi.id"
        :nameRef="servi.name"
        :idRoom="servi.idRoom"
        :room-name="servi.roomName"
        :key="`${servi.id}`"
        type-table="primary"></ServiceTable>

      <div v-if="servi.otherServices.length !== 0">
        <h5 class="texto-destacado d-inline-block">{{idioma.otrosServicios.otros}}</h5>

        <ServiceTable
          :bookingId="servi.booking"
          :idioma="idioma"
          :services="servi.otherServices"
          :idRef="servi.id"
          :nameRef="servi.name"
          :idRoom="servi.idRoom"
          :room-name="servi.roomName"
          :key="`extra_${servi.id}`"
          type-table="extra"></ServiceTable>

      </div>
    </div>

    <label for="observaServicios" v-text="idioma.observaciones"></label>
    <textarea name="observaServicios" id="observaServicios" cols="30" rows="10"
              v-model="servicios.observaciones"></textarea>
    <!--<button @click="modificarRefugio"><i class="fa fa-plus"> Agregar establecimiento</i></button>-->

    <div class="row text-center">
      <div class="col-md-6"><button data-toggle="modal" data-target="#cancelar" class="cancelar margintop20">{{idioma.btnCancelar}}</button></div>
      <div class="col-md-6"><button class="floatingRight margintop20" @click="realizarReserva">{{idioma.btnReserva}}</button></div>
    </div>
    


    <ModalsController :idioma="idioma" modal="servicesInfo"/>
    <ModalsController :idioma="idioma" @cancelar="cancelarReserva" modal="cancelar"/>

  </section>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import ServiceTable from "./ServiceTable";
  import {datesHelper, refugesHelper} from "../../_helpers";
  import {refugeService} from "../../_services";
  import ModalsController from './../modals/ModalsController'

  export default {
    name: "BookingServices",
    props: ["idioma"],

    data() {
      return {
        servicios: {
          desayuno: [],
          comida: [],
          cena: [],
          picnic: [],
          pernocta: [],
          observaciones: ''
        },
        otros: {},
      }
    },

    created() {
      this.getBooking().items.forEach((ref) => {
        let _c = {
          idRefugio: ref.id,
          idHabitacion: ref.idRoom,
          servicios: []
        }
        if (ref.otherServices) {
          Object.keys(ref.otherServices).forEach((srv) => {
            this.otros[ref.id] = {}
            _c['servicios'][ref.checkIn.format('YYYY-MM-DD')] = []
            ref.otherServices[srv].fechas.forEach((_d) => {
              //this.otros[ref.id][_d] = []
              _c['servicios'][_d] = []
            })
          })
          this.otros[ref.id] = _c
        }
        this.startServices()
      })

    },

    computed: {
      currentRefuges() {
        return this.getBooking().items
      }
    },
    methods: {
      ...mapGetters(['getRefuge', 'getBooking' , 'getJoinServices']),
      ...mapMutations(['createServices', 'setPrices']),
      comida(dia, comida = true) {
        if (comida)
          this.servicios.picnic = this.servicios.picnic.filter((p) => p != dia)
        else
          this.servicios.comida = this.servicios.comida.filter((c) => c != dia)
      },
      startServices() {
        this.getBooking().items.forEach(_ref => {
          let _mid = datesHelper.daysBetween(_ref.checkIn, _ref.checkOut)
          let _arr = []
          _mid.forEach(_d => _arr.push(datesHelper.momentToDate(_d)))
          const fechas = [
            datesHelper.momentToDate(_ref.checkIn),
            ..._arr,
            datesHelper.momentToDate(_ref.checkOut)
          ]
          this.createServices({reference: _ref.booking, days: fechas})
        })
      },
      cancelarReserva() {
        this.otros = []
        this.servicios = {
          desayuno: [],
          comida: [],
          cena: [],
          picnic: [],
          pernocta: [],
          observaciones: ''
        }
        this.$emit('cancelBooking')
      },
      realizarReserva() {
        let _tot = 0
        // Obtener las tablas de servicios de cada refugio
        // Por cada tabla obtener cada fila
        this.$children.forEach(_table => {
          // Por cada fila contar los servicios que están seleccionados
          _table.$children.forEach(_row => {
            _row.result.filter(_srv => {
              if (_srv.status === true) _tot++
            })
          })
        })
        // Si hay algún servicio seleccionado se guardan en la reserva
        if (_tot > 0){
          let _toSend = this.getJoinServices()

          _toSend['observaciones'] = this.servicios.observaciones

          refugeService.addPreBookingServices(refugesHelper.prepareToSend(_toSend, 'servicios')).then(data => {
            if (data.response) {
              this.setPrices(data.result)
              this.$emit('toUserData')
            } else {
              this.getBooking().items.forEach(_cur =>
                this.$emit('errorHandler', {errorMessage: data.result[_cur.booking]})
              )
            }
          })
        }
        else
          this.$emit('toUserData')
      }
    },
    components: {
      ServiceTable,
      ModalsController
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/services/BookingServices.vue